import { render, staticRenderFns } from "./SuggestionCourses.vue?vue&type=template&id=7eba27e6"
import script from "./SuggestionCourses.vue?vue&type=script&lang=js"
export * from "./SuggestionCourses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports